export const hasBase = answer => {
  if (!answer) return false

  if (Object.hasOwn(answer, 'base')) return true

  return Object.keys(answer).some(key => answer[key] != null && Object.hasOwn(answer[key], 'base'))
}

export const getChartModeTypes = ({
  answer,
  percentsOnly = false,
  isRType = false,
  isTraitType = false,
  trait = null
}) => {
  const answerHasBase = hasBase(answer)

  if (answerHasBase || percentsOnly) {
    return ['percents', 'bpercents']
  }

  if (isRType || (isTraitType && trait != null)) {
    return ['respondents', 'percents', 'brespondents', 'bpercents']
  }

  return ['pie', 'respondents', 'percents', 'brespondents', 'bpercents']
}

export const getDefaultChartMode = ({ chartMode, globalChartMode, answer, percentsOnly = false, isRType = false }) => {
  const answerHasBase = hasBase(answer)

  let mode = chartMode === 'off' ? globalChartMode : chartMode
  mode = mode || globalChartMode

  if (isRType && mode === 'pie') {
    mode = 'respondents'
  }

  if ((answerHasBase || percentsOnly) && !['percents', 'bpercents'].includes(mode)) {
    return 'percents'
  }

  return mode
}
